import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { loadClientBuroValidationHistory } from 'src/store/actions/clientActions';
import { selectClientBuroValidationHistory } from 'src/store/selectors/clientSelectors';
import { isLoadingSelector } from 'src/store/selectors/statusSelector';
import {
  CLEAR_CLIENT_BURO_VALIDATION_HISTORY,
  LOAD_CLIENT_BURO_VALIDATION_HISTORY
} from 'src/store/constants/clients';
import BuroValidationHistoryTable from './BuroValidationHistoryTable';

const BuroValidationHistoryList = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const histories = useSelector(selectClientBuroValidationHistory);
  const loadingHistories = useSelector(
    isLoadingSelector([LOAD_CLIENT_BURO_VALIDATION_HISTORY.action])
  );

  useEffect(() => {
    dispatch(loadClientBuroValidationHistory(id));
    return () => {
      dispatch({ type: CLEAR_CLIENT_BURO_VALIDATION_HISTORY });
    };
  }, []);

  return (
    <BuroValidationHistoryTable
      loading={loadingHistories}
      histories={histories}
      key="buro-validation-history-table"
    />
  );
};

export default BuroValidationHistoryList;
